function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';
import AbstractInput from '../AbstractInput';
import Button from '../Button';
import Icon from '../Icon';
import { classNamesFor } from '../utils/classNames';
import filterA11YProps from '../utils/filterA11YProps';
/**
 * The Link component behaves just like an A element but with SIE specific
 * style hooks which allow it to be used like a link but look like a CTA
 *
 * - [MDN docs on button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
 *
 * ## Usage
 *
 * ```jsx
 * <Link href="/home">Home Page</Link>
 * ```
 *
 * Make any component a link!
 * ```jsx
 * <Link
 *    href={`/profile/${playerProps.accountId}`}
 *    variant="content"
 * >
 *    <Player {...playerProps} />
 * </Link>
 * ```
 *
 * ## Props
 */

var Link = /*#__PURE__*/function (_AbstractInput) {
  _inherits(Link, _AbstractInput);

  var _super = _createSuper(Link);

  function Link() {
    _classCallCheck(this, Link);

    return _super.apply(this, arguments);
  }

  _createClass(Link, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          forwardedRef = _this$props.forwardedRef,
          ariaLabel = _this$props.ariaLabel,
          ariaDisabled = _this$props.ariaDisabled,
          qa = _this$props.qa,
          id = _this$props.id,
          className = _this$props.className,
          href = _this$props.href,
          download = _this$props.download,
          hrefLang = _this$props.hrefLang,
          ping = _this$props.ping,
          rel = _this$props.rel,
          target = _this$props.target,
          type = _this$props.type,
          variant = _this$props.variant,
          ctaType = _this$props.ctaType,
          size = _this$props.size,
          onClick = _this$props.onClick,
          onKeyDown = _this$props.onKeyDown,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          children = _this$props.children,
          iconOnly = _this$props.iconOnly,
          active = _this$props.active,
          dataTrack = _this$props.dataTrack,
          dataTrackClick = _this$props.dataTrackClick,
          dataTrackContent = _this$props.dataTrackContent,
          dataTelemetryMeta = _this$props.dataTelemetryMeta,
          trackClick = _this$props.trackClick,
          telemetryMeta = _this$props.telemetryMeta,
          chevron = _this$props.chevron,
          disabled = _this$props.disabled,
          a11yProps = _objectWithoutProperties(_this$props, ["forwardedRef", "ariaLabel", "ariaDisabled", "qa", "id", "className", "href", "download", "hrefLang", "ping", "rel", "target", "type", "variant", "ctaType", "size", "onClick", "onKeyDown", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "children", "iconOnly", "active", "dataTrack", "dataTrackClick", "dataTrackContent", "dataTelemetryMeta", "trackClick", "telemetryMeta", "chevron", "disabled"]);

      var _Link$getClassName = Link.getClassName({
        className: className,
        variant: variant,
        ctaType: ctaType,
        size: size,
        iconOnly: iconOnly,
        active: active,
        href: href,
        disabled: disabled
      }),
          root = _Link$getClassName.root,
          contents = _Link$getClassName.contents;

      var resolveChildren = function resolveChildren() {
        if (variant === 'content') return children;
        return /*#__PURE__*/React.createElement("span", {
          className: contents
        }, children, variant === 'standard' && chevron && /*#__PURE__*/React.createElement(Icon, {
          className: "psw-m-l-2",
          size: "2",
          type: "chevron-right"
        }));
      };

      if (disabled || !href) {
        return /*#__PURE__*/React.createElement("span", {
          "data-qa": qa,
          id: id,
          className: root
        }, resolveChildren());
      }

      return /*#__PURE__*/React.createElement("a", _extends({
        ref: forwardedRef
      }, filterA11YProps(a11yProps), {
        "data-qa": qa,
        "data-track": dataTrack,
        "data-track-click": trackClick || dataTrackClick,
        "data-track-content": dataTrackContent,
        "data-telemetry-meta": telemetryMeta || dataTelemetryMeta,
        id: id,
        className: root,
        "aria-label": ariaLabel,
        "aria-disabled": ariaDisabled,
        type: type,
        href: href,
        hrefLang: hrefLang,
        download: download,
        ping: ping,
        rel: rel,
        target: target,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur
      }), resolveChildren());
    }
  }]);

  return Link;
}(AbstractInput);

var cx = classNamesFor(Link);
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for Link
 */

Link.getClassName = function (_ref) {
  var className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'standard' : _ref$variant,
      _ref$ctaType = _ref.ctaType,
      ctaType = _ref$ctaType === void 0 ? '' : _ref$ctaType,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '' : _ref$size,
      isFocused = _ref.isFocused,
      iconOnly = _ref.iconOnly,
      active = _ref.active,
      href = _ref.href,
      disabled = _ref.disabled;
  var buttonClasses = Button.getClassName({
    variant: variant,
    ctaType: ctaType,
    size: size,
    isFocused: isFocused,
    iconOnly: iconOnly,
    active: active,
    disabled: disabled
  });
  var contentsClasses = cx(buttonClasses.contents);
  var applyButtonStyles = /^(solid|tab|quick-action|option|page)$/.test(variant);
  var isTextLink = variant === 'standard' || variant === 'inline';
  return {
    root: cx({
      'psw-link': !ctaType && variant !== 'tab' && variant !== 'page'
    }, "psw-".concat(variant, "-link"), {
      'psw-t-inline-link': href && variant === 'inline'
    }, {
      'psw-l-inline': !href
    }, {
      'psw-t-link': variant === 'standard'
    }, _defineProperty({}, buttonClasses.root, applyButtonStyles), _defineProperty({}, cx('psw-c-t-accent', 'psw-c-t-interactive-1'), !disabled && !!href && isTextLink), {
      'psw-t-size-5': isTextLink && size === 'large'
    }, {
      'psw-t-size-3 psw-t-bold': isTextLink && size === 'small'
    }, disabled && 'psw-c-t-disabled psw-is-disabled', className),
    contents: applyButtonStyles ? contentsClasses : 'psw-l-line-left'
  };
};
/**
 * Defines aliases for classNames used by this component
 */


Link.useClassNames = function (classNames) {
  Link.classNames = classNames;
};

Link.defaultProps = {
  qa: '',
  id: '',
  variant: 'standard',
  size: 'medium',
  ctaType: '',
  chevron: false,
  ariaLabel: '',
  ariaDisabled: false,
  type: '',
  href: null,
  hrefLang: null,
  rel: 'noopener noreferrer',
  className: '',
  iconOnly: false,
  dataTrack: null,
  dataTrackClick: null,
  dataTrackContent: null,
  dataTelemetryMeta: null,
  trackClick: null,
  telemetryMeta: null,
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onKeyDown: function onKeyDown() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {}
};
Link.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * The unique identifier for the button element
   */
  id: PropTypes.string,

  /**
   * Presentational variant to apply
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(['standard', 'inline', 'content', // Button-y
  'solid', 'quick-action', // deprecated
  'outline', 'option']), PropTypes.string]),

  /**
   * The size of the quick action button
   */
  size: PropTypes.oneOf(['', 'small', 'medium', 'large']),

  /**
   * Whether to include the chevron icon at the end of the link content
   */
  chevron: PropTypes.bool,

  /**
   * The type of button in design language
   */
  ctaType: PropTypes.oneOf(['', 'primary', 'secondary', 'tertiary', 'commerce', // Deprecated
  'primary-1', 'primary-2', 'secondary-1', 'alt-secondary', 'secondary-2', 'secondary-3', 'secondary-4', 'utility', 'purchase']),

  /**
   * Link with icon only, used with button styles (e.g. ctaType).
   */
  iconOnly: PropTypes.bool,

  /**
   * Aria label for button. Be aware that screen reader will always use this value if provided
   */
  ariaLabel: PropTypes.string,

  /**
   * Aria annotation to let screen readers know that the UI controlled by the link is
   * perceivable but disabled, so it is not editable or otherwise operable
   */
  ariaDisabled: PropTypes.bool,

  /**
   * The url / path to link to
   */
  href: PropTypes.string,

  /**
   * Hints at the human language of the linked URL. No built-in functionality.
   * Allowed values are the same as the global lang attribute.
   */
  hrefLang: PropTypes.string,

  /**
   * A space-separated list of URLs. When the link is followed, the browser will send
   * POST requests with the body PING to the URLs. Typically for tracking.
   */
  ping: PropTypes.string,

  /**
   * The relationship of the linked URL as space-separated link types.
   */
  rel: PropTypes.string,

  /**
   * Where to display the linked URL, as the name for a browsing context
   * (a tab, window, or <iframe>).
   */
  target: PropTypes.oneOf(['', '_self', '_blank', '_parent', '_top']),

  /**
   * Prompts the user to save the linked URL instead of navigating to it. Can be used with or
   * without a value.
   */
  download: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

  /**
   * The html5 attribute
   */
  type: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * event callback to be called when a user clicks on the button or children within
   */
  onClick: PropTypes.func,

  /**
   * event callback to be called when a key press occurs
   */
  onKeyDown: PropTypes.func,

  /**
   * event callback to be called when a users mouse enters the button or children within
   */
  onMouseEnter: PropTypes.func,

  /**
   * event callback to be called when a users mouse leaves the button or children within
   */
  onMouseLeave: PropTypes.func,

  /**
   * event callback to be called when the button is focused
   */
  onFocus: PropTypes.func,

  /**
   * event callback to be called when the button loses focus
   */
  onBlur: PropTypes.func,

  /**
   * children to be rendered within the button. This is often a label but can be a label and
   * an icon. A button may also wrap any content to "Linkify" it
   */
  children: PropTypes.node.isRequired,

  /**
   * Data attribute read by PDC data layer when user clicks on the button
   */
  dataTrack: PropTypes.string,

  /**
   * **DEPRECATED** use `trackClick` prop instead
   * Data attribute read by web-common-telemetry to tag this element for tracking
   * interactions
   */
  dataTrackClick: PropTypes.string,

  /**
   * Data attribute for Impressions telemetry events
   */
  dataTrackContent: PropTypes.string,

  /**
    * **DEPRECATED** use `telemetryMeta` prop instead
    * Data attribute read by web-common-telemetry to add any meta data to be sent to the
    * spec factories
    */
  dataTelemetryMeta: PropTypes.string,

  /**
    * The spec id identifying the interaction
    */
  trackClick: PropTypes.string,

  /**
   * Serialized json data of context specific telemetry data
   */
  telemetryMeta: PropTypes.string
};
export default Link;